import { Document, DocumentVersion } from "@models";

/**
 * Determines if a document version has changes available for diff viewing.
 *
 * - File-based docs (version.fileId exists): requires changesFileId
 * - Template-based docs: always has a changes file
 */
export const checkVersionHasChanges = (version: DocumentVersion): boolean => {
  const isFileBased = !!version.fileId;

  if (isFileBased) {
    return !!version.changesFileId;
  }

  // Template-based always has cha
  return true;
};

/**
 * Determines if a document version is before the first revision
 * Returns null if the version or document is not provided
 */
export const isVersionBeforeFirstRevision = (
  version?: DocumentVersion,
  document?: Document
): boolean | null => {
  if (!version || !document) {
    return null;
  }

  const firstRevisionCreatedAt = document.versions.find(
    (v) => v.revision === 0
  )?.createdAt;

  if (!firstRevisionCreatedAt) {
    return true;
  }

  return version.createdAt < firstRevisionCreatedAt;
};
